import { render, staticRenderFns } from "./sbxxgl.vue?vue&type=template&id=1093a69f&scoped=true&scope=val&"
import script from "./sbxxgl.vue?vue&type=script&lang=js&"
export * from "./sbxxgl.vue?vue&type=script&lang=js&"
import style0 from "./sbxxgl.vue?vue&type=style&index=0&id=1093a69f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093a69f",
  null
  
)

export default component.exports